export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-shopping-bag-4eb7e3b33c7bae7dbcca063dfd04c2dc.svg";